<template>
  <fragment>
    <div image-fill class="container section-inner illustration-section-01">
      <br /><br />
      <div v-for="item in dataList" :key="item.fields.title">
        <router-link
          :to="`/detail/?type=${type}&id=${item.sys.id}&tag=${item.sys.space.sys.id}`"
          ><a
            href="#"
            style="font-size: 18px; text-decoration: underline; cursor: pointer"
            >{{
              item.fields.title.length > 25
                ? item.fields.title.substring(0, 25)
                : item.fields.title
            }}</a
          ></router-link
        >
        <span style="width: 30%; float: right">{{ item._createTime }}</span>
      </div>
      <div class="page-bar">
        <ul>
          <li v-if="cur > 1"><a v-on:click="cur--, pageClick()">上一页</a></li>
          <li v-if="cur == 1"><a class="banclick">上一页</a></li>
          <li
            v-for="index in indexs"
            v-bind:class="{ active: cur == index }"
            :key="index"
          >
            <a v-on:click="btnClick(index)">{{ index }}</a>
          </li>
          <li v-if="cur != all">
            <a v-on:click="cur++, pageClick()">下一页</a>
          </li>
          <li v-if="cur == all"><a class="banclick">下一页</a></li>
          <li>
            <a
              >共<i>{{ all }}</i
              >页</a
            >
          </li>
        </ul>
      </div>
    </div>

    <c-cta top-divider bottom-divider split />
  </fragment>
</template>

<script>
import CLayout from "@/layouts/LayoutDefault.vue";
import CCta from "@/components/sections/Cta.vue";

export default {
  name: "Home",
  components: {
    CCta,
  },
  data() {
    return {
      originalDataList: [],
      dataList: [],
      all: 0, //总页数
      cur: 1, //当前页码
      count: 10, //每页显示多少
      type: "H",
    };
  },
  created() {
    this.$emit("update:layout", CLayout);
    this.initializeData(1);
  },
  watch: {
    $route() {
      this.initializeData(1);
    },
  },
  computed: {
    //分页
    indexs: function () {
      var left = 1;
      var right = this.all;
      var ar = [];
      if (this.all >= 5) {
        if (this.cur > 3 && this.cur < this.all - 2) {
          left = this.cur - 2;
          right = this.cur + 2;
        } else {
          if (this.cur <= 3) {
            left = 1;
            right = 5;
          } else {
            right = this.all;
            left = this.all - 4;
          }
        }
      }
      while (left <= right) {
        ar.push(left);
        left++;
      }
      return ar;
    },
  },
  mounted() {},
  methods: {
    initializeData(index) {
      this.type = "N"; // 消息
      if (window.location.search.indexOf("H") > 0) {
        this.type = "H"; // 文档
      }

      this.$axios
        .get(
          "https://cdn.contentful.com/spaces/tg92i1fck5ws/environments/master/entries?access_token=wVryCvO_gFJfPY34V4KTn9gDxZeEa3lNWHkra043a7c"
        )
        .then((res) => {
          if (res.data != null) {
            this.originalDataList = [];
            const items = res.data.items || [];
            for (let i = 0; i < items.length; i++) {
              if (
                this.type === "H" &&
                items[i].sys.contentType.sys.id !== "news"
              ) {
                this.originalDataList.push(items[i]);
              } else if (
                this.type === "N" &&
                items[i].sys.contentType.sys.id === "news"
              ) {
                this.originalDataList.push(items[i]);
              }
            }
            this.all = Math.ceil(this.originalDataList.length / this.count); //总页数
            this.cur = index;
            this.dataListFn();
          }
        });
    },
    //替换api不支持分页获取数据，所以前端分页
    dataListFn: function () {
      this.dataList = this.originalDataList.slice(
        (this.cur - 1) * this.count,
        this.cur * this.count
      );
    },
    //分页
    btnClick: function (data) {
      //页码点击事件
      if (data != this.cur) {
        this.cur = data;
      }
      //根据点击页数请求数据
      this.dataListFn();
    },
    pageClick: function () {
      //根据点击页数请求数据
      this.dataListFn();
    },
    getLocalTime: function (da) {
      var date_ = new Date(da);
      var year = date_.getFullYear();
      var month = date_.getMonth() + 1;
      var day = date_.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;

      var hours = date_.getHours();
      var mins = date_.getMinutes();
      var secs = date_.getSeconds();
      var msecs = date_.getMilliseconds();
      if (hours < 10) hours = "0" + hours;
      if (mins < 10) mins = "0" + mins;
      if (secs < 10) secs = "0" + secs;
      if (msecs < 10) secs = "0" + msecs;
      return year + "-" + month + "-" + day + " " + hours + ":" + mins;
    },
  },
};
</script>

<style>
/*分页*/
.page-bar {
  margin: 0px auto;
  margin-top: 10px;
  margin-left: -20px;
}
ul,
li {
  margin: 0px;
  padding: 0px;
}
li {
  list-style: none;
}
.page-bar li:first-child > a {
  margin-left: 0px;
}
.page-bar a {
  border: 1px solid #ddd;
  text-decoration: none;
  position: relative;
  float: left;
  padding: 3px 10px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #5d6062;
  cursor: pointer;
  margin-right: 10px;
}
.page-bar a:hover {
  background-color: #eee;
}
.page-bar a.banclick {
  cursor: not-allowed;
}
.page-bar .active a {
  color: #fff;
  cursor: default;
  background-color: #afccf1;
  border-color: #afccf1;
}
.page-bar i {
  font-style: normal;
  color: #d44950;
  margin: 0px 4px;
  font-size: 19px;
}
</style>
